import { useTheme } from "@repo/tokens";
import { resolveThemeToken } from "../../utils/theme";
import type { TextProps } from "./types";

export const useStyles = (props: TextProps) => {
  const { theme } = useTheme();

  const {
    variant = "body",
    size = "medium",
    weight = "regular",
    color,
    align,
    ellipsis,
  } = props;

  const isOverline = variant === "overline";
  const isCaption = variant === "caption";

  type ThemeVariant = "body" | "label";

  const themeVariant: ThemeVariant =
    isOverline || isCaption ? "label" : variant;

  const baseToken =
    theme.typography[themeVariant]?.[size]?.[weight] ??
    theme.typography.body.small.regular;

  return {
    "--text-font-size": `${
      isOverline ? baseToken.fontSize * 0.9 : baseToken.fontSize
    }px`,
    "--text-line-height": baseToken.lineHeight,
    "--text-font-family": baseToken.fontFamily,
    "--text-font-weight": baseToken.fontWeight,
    "--text-letter-spacing": isOverline
      ? Math.max(baseToken.letterSpacing ?? 0, 1.2)
      : (baseToken.letterSpacing ?? "normal"),
    "--text-color": color ? resolveThemeToken(theme, color) : baseToken.color,
    "--text-align": align ?? "left",
    "--text-transform": isOverline ? "uppercase" : "none",
    "--text-white-space": ellipsis ? "nowrap" : "normal",
    "--text-overflow": ellipsis ? "ellipsis" : "clip",
    margin: 0,
  } as React.CSSProperties;
};
